import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { TenantCustomImageDetailsComponent } from './tenant-custom-image-details.component';
import { ExternalTenantGuard } from 'src/app/services/util/external-tenant.guard';

const routes: Routes = [
  {
    path: '',
    component: TenantCustomImageDetailsComponent,
    title: 'Custom Image Details',
    canActivate: [ExternalTenantGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantCustomImageDetailsRoutingModule {
}